import { create } from 'zustand';

import { AppRouteKeys } from '~/core/router/router_utils';

interface NavigationState {
  currentRoute: AppRouteKeys | null;
  previousRoute: AppRouteKeys | null;
  setRoute: (route: AppRouteKeys) => void;
}

// Define state updater type
type SetState = (fn: (state: NavigationState) => Partial<NavigationState>) => void;

export const useNavigationStore = create<NavigationState>((set: SetState) => ({
  currentRoute: null,
  previousRoute: null,
  setRoute: (route: AppRouteKeys) =>
    set((state: NavigationState) => ({
      previousRoute: state.currentRoute,
      currentRoute: route,
    })),
}));

// Note: You may need to install the zustand package with:
// npm install zustand
